if (window.document.documentMode) {
    document.querySelector("#ieBanner").style.display = "flex";
    document.querySelector("#loginForm").style.pointerEvents = "none";
}

//# sourceMappingURL=views.d5d11b1e.js.map
